import React, { useEffect, useState } from 'react';

export default function MediaSearchInput({ value, onSearch }) {
  const [draft, setDraft] = useState(value || '');

  useEffect(() => {
    setDraft(value || '');
  }, [value]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearch(draft);
    }, 400);

    return () => clearTimeout(timeout);
  }, [draft, onSearch]);

  return (
    <label className="mp-media-picker-search">
      <span className="mp-media-picker-search__icon" aria-hidden="true">⌕</span>
      <input
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onSearch(draft);
          }
        }}
        placeholder="Buscar mídia..."
        aria-label="Buscar mídia"
      />
    </label>
  );
}
